export const SET_LOADING = 'SET_LOADING';
export const GET_ITEMS = 'GET_ITEMS';
export const GET_ITEMS_FAIL = 'GET_ITEMS_FAIL';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATE_ITEM_FAIL = 'UPDATE_ITEM_FAIL';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_ITEM_FAIL = 'DELETE_ITEM_FAIL';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const SET_ITEM = 'SET_ITEM';
export const CLEAR_ITEM = 'CLEAR_ITEM';
export const GET_ITEM_DETAIL = 'GET_ITEM_DETAIL';
export const GET_ITEM_DETAIL_SUCCESS = 'GET_ITEM_DETAIL_SUCCESS';
export const GET_ITEM_DETAIL_FAIL = 'GET_ITEM_DETAIL_FAIL';
export const SHARE_ITEM = 'SHARE_ITEM';
export const SHARE_ITEM_SUCCESS = 'SHARE_ITEM_SUCCESS';
export const UPVOTE_ITEM = 'UPVOTE_ITEM';
export const UPVOTE_ITEM_SUCCESS = 'UPVOTE_ITEM_SUCCESS';
export const UPVOTE_ITEM_FAIL = 'UPVOTE_ITEM_FAIL';
export const DELETE_UPVOTE_ITEM = 'DELETE_UPVOTE_ITEM';
export const DELETE_UPVOTE_ITEM_SUCCESS = 'DELETE_UPVOTE_ITEM_SUCCESS';
export const DELETE_UPVOTE_ITEM_FAIL = 'DELETE_UPVOTE_ITEM_FAIL';
export const FAVORITE_ITEM = 'FAVORITE_ITEM';
export const FAVORITE_ITEM_SUCCESS = 'FAVORITE_ITEM_SUCCESS';
export const FAVORITE_ITEM_FAIL = 'FAVORITE_ITEM_FAIL';
export const DELETE_FAVORITE_ITEM = 'DELETE_FAVORITE_ITEM';
export const DELETE_FAVORITE_ITEM_SUCCESS = 'DELETE_FAVORITE_ITEM_SUCCESS';
export const DELETE_FAVORITE_ITEM_FAIL = 'DELETE_FAVORITE_ITEM_FAIL';
export const UPDATE_SHORT_URL = 'UPDATE_SHORT_URL';
export const UPDATE_SHORT_URL_SUCCESS = 'UPDATE_SHORT_URL_SUCCESS';
export const UPDATE_SHORT_URL_FAIL = 'UPDATE_SHORT_URL_FAIL';
export const GET_UPDATED_ITEMS = 'GET_UPDATED_ITEMS';
export const GET_DELETED_ITEMS = 'GET_DELETED_ITEMS';
export const ADD_TAG_TO_ITEM = 'ADD_TAG_TO_ITEM';
export const UPDATE_TAGS_FOR_ITEMS = 'UPDATE_TAGS_FOR_ITEMS';
export const REMOVE_TAG_FROM_ITEM = 'REMOVE_TAG_FROM_ITEM';
export const GET_IMPORT_HISTORY = 'GET_IMPORT_HISTORY';
export const GET_IMPORT_HISTORY_SUCCESS = 'GET_IMPORT_HISTORY_SUCCESS';
export const GET_IMPORT_HISTORY_FAILURE = 'GET_IMPORT_HISTORY_FAILURE';
export const CREATE_IMPORT_HISTORY = 'CREATE_IMPORT_HISTORY';
export const CREATE_IMPORT_HISTORY_SUCCESS = 'CREATE_IMPORT_HISTORY_SUCCESS';
export const CREATE_IMPORT_HISTORY_FAILURE = 'CREATE_IMPORT_HISTORY_FAILURE';
export const UPDATE_HISTORY_STATUS = 'UPDATE_HISTORY_STATUS';
export const UPDATE_HISTORY_STATUS_SUCCESS = 'UPDATE_HISTORY_STATUS_SUCCESS';
export const UPDATE_HISTORY_STATUS_FAILURE = 'UPDATE_HISTORY_STATUS_FAILURE';
export const DELETE_IMPORT_HISTORY = 'DELETE_IMPORT_HISTORY';
export const DELETE_IMPORT_HISTORY_SUCCESS = 'DELETE_IMPORT_HISTORY_SUCCESS';
export const DELETE_IMPORT_HISTORY_FAILURE = 'DELETE_IMPORT_HISTORY_FAILURE';
export const UPDATE_FILTERED_ITEMS = 'UPDATE_FILTERED_ITEMS';

export const getItems = () => ({
  type: GET_ITEMS
});

export const getItemsFail = (error) => ({
  type: GET_ITEMS_FAIL,
  error
});

export const getItemsSuccess = (items) => ({
  type: GET_ITEMS_SUCCESS,
  items
});

export const updateItem = newDetails => ({
  type: UPDATE_ITEM,
  newDetails
});

export const updateItemFail = (error, itemId) => ({
  type: UPDATE_ITEM_FAIL,
  error,
  itemId
});

export const updateItemSuccess = (item) => ({
  type: UPDATE_ITEM_SUCCESS,
  item
});

export const deleteItem = (id) => ({
  type: DELETE_ITEM,
  id
});

export const deleteItemFail = (error) => ({
  type: DELETE_ITEM_FAIL,
  error
});

export const deleteItemSuccess = (id) => ({
  type: DELETE_ITEM_SUCCESS,
  id
});

export const setItem = (itemId) => ({
  type: SET_ITEM,
  itemId
});

export const getItemDetail = (id) => ({
  type: GET_ITEM_DETAIL,
  id
});

export const getItemDetailSuccess = (detail) => ({
  type: GET_ITEM_DETAIL_SUCCESS,
  detail
});

export const getItemDetailFail = (error) => ({
  type: GET_ITEM_DETAIL_FAIL,
  error
});

export const clearItem = (id) => ({
  type: CLEAR_ITEM,
  id
});

export const shareItem = (shareInfo) => ({
  type: SHARE_ITEM,
  id: shareInfo.id,
  sharedTo: shareInfo.sharedTo,
  shortUrl: shareInfo.shortUrl,
  shareId: shareInfo.shareId,
  itemType: shareInfo.itemType,
  ctaId: shareInfo.ctaId
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  isLoading
});

export const shareItemSuccess = (shortInfo) => ({
  type: SHARE_ITEM_SUCCESS,
  shortInfo
});

export const upvoteItem = (id) => ({
  type: UPVOTE_ITEM,
  id
});

export const deleteUpvoteItem = (id) => ({
  type: DELETE_UPVOTE_ITEM,
  id
});

export const favoriteItem = (id) => ({
  type: FAVORITE_ITEM,
  id
});

export const deleteFavoriteItem = (id) => ({
  type: DELETE_FAVORITE_ITEM,
  id
});

export const updateShortUrl = (id, path, newPath) => ({
  type: UPDATE_SHORT_URL,
  id,
  path,
  newPath
});

export const updateShortUrlSuccess = (id, data) => ({
  type: UPDATE_SHORT_URL_SUCCESS,
  id,
  data
});

export const updateShortUrlFail = (error) => ({
  type: UPDATE_SHORT_URL_FAIL,
  error
});

export const getUpdatedItems = (items) => ({
  type: GET_UPDATED_ITEMS,
  items
});

export const getDeletedItems = (items) => ({
  type: GET_DELETED_ITEMS,
  items
});

export const addTagToItem = (itemId, tagName, params) => ({
  type: ADD_TAG_TO_ITEM,
  itemId,
  tagName,
  params
});

export const updateTagsForItems = (itemIds, tags) => ({
  type: UPDATE_TAGS_FOR_ITEMS,
  itemIds,
  tags
})

export const removeTagFromItem = (itemId, tagName) => ({
  type: REMOVE_TAG_FROM_ITEM,
  itemId,
  tagName
});

export const getImportHistory = () => ({
  type: GET_IMPORT_HISTORY
});

export const getImportHistorySuccess = (histories) => ({
  type: GET_IMPORT_HISTORY_SUCCESS,
  histories
});

export const getImportHistoryFailure = (error) => ({
  type: GET_IMPORT_HISTORY_SUCCESS,
  error
});

export const createImportHistory = (historyData) => ({
  type: CREATE_IMPORT_HISTORY,
  historyData
});

export const createImportHistorySuccess = (historyData) => ({
  type: CREATE_IMPORT_HISTORY_SUCCESS,
  historyData
});

export const createImportHistoryFailure = (error) => ({
  type: CREATE_IMPORT_HISTORY_FAILURE,
  error
});
 
export const updateHistoryStatus = (status, importId) => ({
  type: UPDATE_HISTORY_STATUS,
  status,
  importId
});

export const updateHistoryStatusSuccess = (historyData) => ({
  type: UPDATE_HISTORY_STATUS_SUCCESS,
  historyData
});

export const updateHistoryStatusFailure = (error) => ({
  type: UPDATE_HISTORY_STATUS_FAILURE,
  error
});

export const deleteImportHistory = (importId) => ({
  type: DELETE_IMPORT_HISTORY,
  importId
});

export const deleteImportHistorySuccess = (historyData) => ({
  type: DELETE_IMPORT_HISTORY_SUCCESS,
  historyData
});

export const deleteImportHistoryFailure = (error) => ({
  type: DELETE_IMPORT_HISTORY_FAILURE,
  error
});

export const updateFilteredItems = items => ({
  type: UPDATE_FILTERED_ITEMS,
  items
});
